import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { AnomalyMarkdownPipe } from '@app/features/anomalies/anomaly-markdown-pipe';
import { TipsComponent } from '@app/shared/tips/tips.component';
import { LucideCompass, LucideX } from '@lucide/angular';
import { announcementMeta } from '../announcement-presentation';
import { BannerAnnouncement } from '../announcement.model';

/**
 * Le bandeau d'une nouveauté, sous ceux des anomalies (RG-nouveaute-annonce) : sa propre icône et
 * la couleur primaire, et il se ferme. « Découvrir », hors du Markdown, ouvre le parcours qu'il
 * propose dans un onglet de démonstration.
 */
@Component({
  selector: 'app-announcement-banner',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TipsComponent,
    MatButtonModule,
    MatTooltip,
    AnomalyMarkdownPipe,
    LucideCompass,
    LucideX,
  ],
  templateUrl: './announcement-banner.html',
  styleUrls: ['../../anomalies/anomaly-banner/anomaly-banner.scss', './announcement-banner.scss'],
})
export class AnnouncementBanner {
  readonly announcement = input.required<BannerAnnouncement>();
  /** L'adresse de l'onglet de démonstration ; `null` quand l'utilisateur ne peut pas le suivre. */
  readonly tourHref = input<string | null>(null);
  /** Sans actions, le bandeau sert d'aperçu dans le dialogue de saisie. */
  readonly actions = input(true);

  readonly dismiss = output<void>();

  protected readonly meta = computed(() => announcementMeta(this.announcement()));
}
